import "./styles/WhatIsGrid.css";

function WhatIsGrid() {
  return (
    <div className="GridAreaContainer">
      <div className="gridTitleContent">
        <h1 className="titleText">
          Wat is <span className="angledUnderline">Grid Area</span> nou
          eigenlijk??
        </h1>
      </div>

      <div className="gridareaContainer">
        <div className="gridbox1">
          <h2 className="wieGridAreaText">
            Apps <br /> Websites <br /> En Web-Apps{" "}
          </h2>
          {/* <p className="wieuitlegText">
            Wij zijn een jonge groep app ontwikkelaars. Begonnen vanuit Utrecht.{" "}
          </p> */}
        </div>
        <div className="gridbox2">
          <h1 className="wieText skilltext">Skill Set:</h1>
          <ul className="gridSkillSet">
            <li>React-Native</li>
            <li>React</li>
            <li>JavaScript</li>
            
            <li>HTML</li>
            <li>CSS</li>
            
            <li>TypeScript</li>
          </ul>
        </div>
        <div className="gridbox3">
          <h1 className="wieText">Styling?</h1>
          <p className="wieInhoudText">
            Strak? <br /> Modern? <br /> Kleurrijk? <br /> Jouw Wens, Onze
            Oplossing
          </p>
        </div>
      </div>
    </div>
  );
}

export default WhatIsGrid;
